import { VueExtension } from '../../utils/extensions/vue';
import ActionSheet from './actionsheet.jsx';
import './actionsheet.scss';

VueExtension.WithInstall(ActionSheet);

export default ActionSheet;
